/**
 * MrRizz – výměna vzorku za větší objem.
 * Odebere původní řádek a přidá doporučenou variantu ve spočítaném počtu kusů.
 */
(() => {
  const json = { 'Content-Type': 'application/json' };

  window.addEventListener('click', async (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const btn = target?.closest('.cart-sample-upgrade__action');
    if (!btn) return;

    event.preventDefault();
    event.stopPropagation();
    if (btn.dataset.busy === '1') return;
    btn.dataset.busy = '1';
    btn.setAttribute('aria-busy', 'true');

    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: json,
        body: JSON.stringify({ id: btn.dataset.lineKey, quantity: 0 }),
      });
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: json,
        body: JSON.stringify({
          id: Number(btn.dataset.variantId),
          quantity: Number(btn.dataset.quantity) || 1,
        }),
      });
      window.location.reload();
    } catch (error) {
      console.error('[MrRizz] Výměna vzorku selhala:', error);
      btn.dataset.busy = '';
      btn.removeAttribute('aria-busy');
    }
  });
})();
